module.exports = __webpack_public_path__ + "static/analog-photo-24-276bff48070fcd2438854e43bb44296d.jpg";